const DEFAULT_SIZE = {
  CAMPAIGNS: 48,
};

export { DEFAULT_SIZE };
